import { Map } from 'immutable'
import _ from 'lodash'

import { REPORT_NAVIGATION_TOGGLE_EXPANDED, REPORT_NAVIGATION_SET_POSITION } from './constants'

const initialState = Map({
    expanded: false,
    position: 0,
    maxPosition: 0,
})

export default function navigationReducer(state = initialState, action = {}) {
    switch (action.type) {
        case REPORT_NAVIGATION_TOGGLE_EXPANDED: {
            return state.set('expanded', !state.get('expanded'))
        }
        case REPORT_NAVIGATION_SET_POSITION: {
            const position = _.get(action, 'data.position', 0)
            const maxPosition = _.get(action, 'data.maxPosition', 0)

            return state.set('position', position).set('maxPosition', maxPosition)
        }
        default:
            return state
    }
}
